import React, { useEffect, useState } from 'react';
import ContentLoader from 'react-content-loader';
import { If, When, Choose, Otherwise } from 'babel-plugin-jsx-control-statements';
import { useHistory } from 'react-router-dom';
import {
	Pulse,
	getCurrentEnv,
	NetworkHelper,
	Button,
	FooterLines,
	useDeviceType,
	RegexValidationUI,
	fetchPropertyConfig
} from 'common-utilities';
import { EVENT_CATEGORY, SCREEN_NAME } from '../../constants';
import NProgress from 'nprogress';
import Shield from '../../assets/paytmSheild.svg';
import VisibilityIcon from '../../assets/visibility-icon.png';
import PasswordInput from '../../components/PasswordInput';
import './style.scss';
import 'nprogress/nprogress.css';

const ENV = getCurrentEnv();
const screenName = SCREEN_NAME + '_home';
const params = new URLSearchParams(window.location.search);
const sourceFlow = params.get('source_flow') || '';
const enableLogoutConsent = params.get('logoutFromAllEnabled') !== 'false' ? true : false;
NProgress.configure({ showSpinner: false });
function Home({ state }) {
	const DEVICE = useDeviceType();
	const [userDetails, setUserDetails] = useState({});
	const history = useHistory();
	const [apiStatus, setApiStatus] = useState(NetworkHelper.API_STATUS.NOT_STARTED);
	const [newPass, setNewPass] = useState('');
	const [confirmPass, setConfirmPass] = useState('');
	const [strengthLabel, setStrengthLabel] = useState('');
	const [showPassword, setShowPassword] = useState(false);
	const [showNewPassword, setShowNewPassword] = useState(false);
	const [error, setError] = useState('');
	const [logoutConsent, setLogoutConsent] = useState(false);
	const [showLoader, setShowLoader] = useState(false);
	const [ruleError, setRuleError] = useState(false);
	const [ruleErrorMsg, setRuleErrorMsg] = useState();
	const [groups, setGroups] = useState([]);
	function handleResponseCodes(data) {
		const { responseCode, message = '', status = '' } = data;
		switch (responseCode) {
			case 'BE1422003':
			case 'BE1426001':
			case 'BE1426002':
			case 'BE1423004':
			case 'BE1423005':
			case 'BE1423006':
				history.push('/error');
				break;
			case 'BE1426030':
			case 'BE1424037':
				setError(message);
				Pulse.push({
					event_action: 'proceed_clicked',
					event_category: EVENT_CATEGORY,
					screenName,
					event_label: message,
					event_label2: 'api',
					event_label3: strengthLabel,
					event_label4: logoutConsent
				});
				break;
			default:
				if (status !== 'SUCCESS') {
					history.push('/error');
				}
		}
	}
	const setConfigData = async () => {
		sessionStorage &&
			sessionStorage.setItem(
				'REDIRECT_PAYTM_DEEPLINK',
				await fetchPropertyConfig('redirectPaytmDeepLink')
			);
		setLogoutConsent(
			(await fetchPropertyConfig('userLogoutConsent')) === 'LOGOUT_FROM_ALL_DEVICES' &&
				enableLogoutConsent
				? true
				: false
		);
	};
	useEffect(() => {
		setApiStatus(NetworkHelper.API_STATUS.INITIALIZED);
		setConfigData();
		NetworkHelper.get(`${ENV}/user/token/info?stateCode=${state.code}`)
			.then(data => {
				setUserDetails(data);
				setApiStatus(NetworkHelper.API_STATUS.SUCCESS);
				sessionStorage && sessionStorage.setItem('USER_DETAIL', JSON.stringify(data));
				setTimeout(() => {
					Pulse.push({
						event_action: 'password_reset_screen_loaded',
						event_category: EVENT_CATEGORY,
						screenName,
						event_label: 'valid',
						event_label2: sourceFlow
					});
				});
			})
			.catch(err => {
				setApiStatus(NetworkHelper.API_STATUS.FAILURE);
				history.push('/error');
			});
	}, []);

	const onProceed = () => {
		if (!newPass || !confirmPass) {
			setError('Password should not be blank');
			Pulse.push({
				event_action: 'proceed_clicked',
				event_category: EVENT_CATEGORY,
				screenName,
				event_label: 'Password should not be blank',
				event_label2: 'front end',
				event_label4: logoutConsent
			});
			return;
		}
		if (newPass !== confirmPass) {
			setError('Password and Confirm Password must match');
			Pulse.push({
				event_action: 'proceed_clicked',
				event_category: EVENT_CATEGORY,
				screenName,
				event_label: 'Password and Confirm Password must match',
				event_label2: 'front end',
				event_label4: logoutConsent
			});
			return;
		}
		if (ruleError) {
			return;
		}
		setShowLoader(true);
		NetworkHelper.post(`${ENV}/um/v3/updateFromResetLink`, {
			code: state.code,
			password: newPass,
			rePassword: confirmPass,
			userLogoutConsent: logoutConsent
				? sourceFlow === 'report_fraud'
					? 'LOGOUT_FROM_ALL_DEVICES_WITHOUT_ST'
					: 'LOGOUT_FROM_ALL_DEVICES'
				: 'LOGOUT_FROM_NONE'
		})
			.then(data => {
				setShowLoader(false);
				handleResponseCodes(data);
				if (data.status === 'SUCCESS') {
					sessionStorage && sessionStorage.setItem('CODE', state.code);
					sessionStorage &&
						sessionStorage.setItem('USER_MOBILE', userDetails.moblieNumber || '');
					sessionStorage && sessionStorage.setItem('USER_EMAIL', userDetails.email || '');
					Pulse.push({
						event_action: 'proceed_clicked',
						event_category: EVENT_CATEGORY,
						screenName,
						event_label3: strengthLabel,
						event_label4: logoutConsent
					});
					history.push('/success');
				}
			})
			.catch(err => {
				setShowLoader(false);
				history.push('/error');
			});
	};

	const onPasswordBlur = () => {
		if (newPass.length > 0) {
			Pulse.push({
				event_action: 'new_password_entered',
				event_category: EVENT_CATEGORY,
				screenName
			});
		}
		let verify = groups.reduce((partialSum, a) => partialSum + a.completed, 0) != groups.length;
		setRuleError(verify);
		if (verify && newPass.length > 0) {
			setRuleErrorMsg('Password should meet below requirements');
		} else {
			setRuleErrorMsg();
		}
	};

	const onConfirmPassBlur = () => {
		if (confirmPass.length > 0) {
			Pulse.push({
				event_action: 'confirm_password_entered',
				event_category: EVENT_CATEGORY,
				screenName
			});
		}
	};

	const onStrengthChange = strength => {
		setStrengthLabel(strength);
	};

	const onLogoutConsentChange = () => {
		setLogoutConsent(!logoutConsent);
	};

	return (
		<React.Fragment>
			<div className="homePageContainer">
				<div className="header-logo-cont">
					<img className="sheild-img" src={Shield} alt="shield-icon" />
				</div>
				<Choose>
					<When condition={apiStatus === NetworkHelper.API_STATUS.SUCCESS}>
						<div className="infoContainer">
							<div className="heading">
								Reset Password for{' '}
								{userDetails.moblieNumber
									? `Mobile Number ${userDetails.moblieNumber}`
									: `Email ${userDetails.email}`}
							</div>
							<div>
								<div className="password-cont">
									<PasswordInput
										name="newPass"
										value={newPass}
										passwordrules={userDetails.iosPasswordRule || ''}
										onChange={e => setNewPass(e.target.value)}
										onBlur={e => onPasswordBlur()}
										placeholder={'Enter New Paytm Password'}
										type={showNewPassword ? 'text' : 'password'}
										label="Enter New Paytm Password"
										oauth-id="new_pwd_input"
									/>
									<div
										className="show-password-icon"
										onClick={e =>
											newPass.length > 0 &&
											setShowNewPassword(!showNewPassword)
										}
										style={{ opacity: newPass.length > 0 ? '1' : '0.6' }}
									>
										<img src={VisibilityIcon} />
									</div>
									{newPass && ruleErrorMsg?.length > 0 && (
										<div className="rule-error-cont">
											<span>{ruleErrorMsg}</span>
										</div>
									)}
									<RegexValidationUI
										value={newPass}
										userDetails={userDetails}
										updateGroup={setGroups}
									/>
								</div>
								<div className="password-cont">
									<PasswordInput
										name="confirmPass"
										value={confirmPass}
										passwordrules={userDetails.iosPasswordRule || ''}
										onChange={e => setConfirmPass(e.target.value)}
										placeholder={'Confirm Password'}
										onBlur={e => onConfirmPassBlur()}
										type={showPassword ? 'text' : 'password'}
										label="Confirm Password"
										oauth-id="confirm_pwd_input"
									/>
									<div
										className="show-password-icon"
										onClick={e =>
											confirmPass.length > 0 && setShowPassword(!showPassword)
										}
										style={{ opacity: confirmPass.length > 0 ? '1' : '0.6' }}
									>
										<img src={VisibilityIcon} />
									</div>
								</div>
							</div>
						</div>
						{!error && (
							<div
								key="error-place-holder"
								className="error-place-holder"
								style={{ marginTop: '30px' }}
							></div>
						)}
						{error && (
							<div className="error-cont">
								<span>{error}</span>
							</div>
						)}
						<div className="footer-action-cont">
							<If condition={enableLogoutConsent}>
								<div className="logout-consent-cont">
									<input
										type="checkbox"
										style={{ cursor: 'pointer' }}
										checked={logoutConsent}
										onChange={e => onLogoutConsentChange()}
										oauth-id="logout_checkbox"
									/>
									<div className="consent-helptext">
										<p className="label">Log me out from all apps & devices</p>
										<p className="helptext">
											You have to login on all devices again{' '}
										</p>
									</div>
								</div>
							</If>
							<div className="buttonContainer">
								<Button
									isSpinnerVisible={showLoader}
									onClick={e =>
										apiStatus === NetworkHelper.API_STATUS.SUCCESS
											? onProceed(e)
											: null
									}
									oauth-id="proceed_btn"
								>
									Proceed
								</Button>
							</div>
						</div>
					</When>
					<Otherwise>
						<ContentLoader animate={true} width={200} viewBox="0 0 200 70">
							<rect x="0" y="4" rx="2" ry="2" width="200" height="8" />
							<rect x="0" y="20" rx="2" ry="2" width="200" height="8" />
							<rect x="0" y="36" rx="2" ry="2" width="160" height="8" />
							<rect x="0" y="52" rx="2" ry="2" width="200" height="8" />
						</ContentLoader>
					</Otherwise>
				</Choose>
				<FooterLines />
			</div>
		</React.Fragment>
	);
}
export default Home;
